/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Sales_Return_Lot_ReturnableInputs */

const vi_sales_return_lot_returnable = /** @type {(inputs: Sales_Return_Lot_ReturnableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(còn trả được ${i?.qty})`)
};

/**

* @param {Sales_Return_Lot_ReturnableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_lot_returnable = /** @type {((inputs: Sales_Return_Lot_ReturnableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Lot_ReturnableInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_lot_returnable(inputs)
});